'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardAdminCtrl', ['$uibModal', '$state', '$scope', 'dialog', 'Tenant', '$translate', 'Member', require('./dashboardAdminCtrl')]);
app.config(['$stateProvider', require('./dashboardAdminConfig')]);
